(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/play/game-picker-header.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/play/game-picker-header.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.GamePickerHeader = Marionette.View.extend({
    className: 'f-bold',

    ui: {
      closeMenuBtn: '.js-close-menu-btn'
    },

    triggers: {
      'click @ui.closeMenuBtn': 'closeMenu'
    },

    template: function(data) {
      return svs.bingo.templates.game_picker_header(data);
    },

    onCloseMenu: function() {
      svs.components.headerslidedownmenu.hide();
    }
  });
})(Backbone, _, svs);


 })(window);